import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IconArrow } from "icons";
import IntegrationsHub from "pages/IntegrationsPage/IntegrationsHub";
import { PATHS } from "router/config/paths";
import { useAppSelector } from "store";

/**
 * Account → Connected Apps. The same Integrations hub the sidebar page uses, in its compact mode (the connection cards), plus a header row
 * with a link to the full page. The link lives HERE, in the Account module, so its testid stays page-owned in `ui-map` (`testids`, not the
 * `testids_via_components` hint, which is held under a ceiling — scripts/lib/fe-source.test.js).
 */
const Integrations = () => {
  const { t } = useTranslation();
  // /integrations is a paid-plan route (`paidPlanNeeded`, enforced by AuthorizationPage on `common.isAuthorized`; the side menu greys it out the same way).
  const { isAuthorized } = useAppSelector((state) => state.common);

  return (
    <div className="flex flex-col gap-4" data-testid="account-integrations">
      {isAuthorized && (
        <div className="flex items-center justify-between gap-4">
          <p className="min-w-0 text-bodySm text-grey">{t("account:integrations.manage_intro")}</p>
          <Link to={PATHS.INTEGRATIONS} data-testid="integrations-hub-open" className="flex shrink-0 items-center gap-1 text-bodySm text-purpleGreen hover:underline">
            {t("account:integrations.open_integrations")}
            <IconArrow aria-hidden="true" className="h-4 w-4" />
          </Link>
        </div>
      )}
      <IntegrationsHub mode="compact" />
    </div>
  );
};

export default Integrations;
